import { Alert } from "@mui/material";
import TitleHeaders from "../../../Components/CluppForms/TitleHeaders";

const CancelationConfirmation = ({ state, setState, field }) => {
  const { products } = state;
  let title = "";
  let subtitle = "Nuevamente lamentamos que te vayas 😢.";

  if (products && products.length > 0) {
    const { brand, model, year } = products[0] || {};

    if (state.isMoreThanOne) {
      title =
        "¿Estás seguro de querer cancelar los seguros que tienes contratados?";
    } else {
      title = `¿Estás seguro de querer cancelar el seguro de tu ${brand} ${model} ${
        year || ""
      }?`;
    }
  } else {
    if (state.isMoreThanOne) {
      title =
        "¿Estás seguro de querer cancelar los seguros que tienes contratados?";
    } else {
      title = "¿Estás seguro de querer cancelar tu seguro?";
    }
  }

  return (
    <>
      <TitleHeaders title={title} subtitle={subtitle} isRequired={true} />
      <Alert severity="error">
        Estás a punto de cancelar tu seguro. Esta acción es irreversible y
        perderás acceso a todos tus beneficios. ¿Estás seguro de que deseas
        continuar?
      </Alert>
    </>
  );
};
export default CancelationConfirmation;
